module.exports = __webpack_public_path__ + "img/permission_empty.a715ae2e.png";